export const TRANSLATIONS = {
  fr: {
    nav: {
      links: [
        { href: "#about", label: "about" },
        { href: "#stack", label: "stack" },
        { href: "#exp", label: "parcours" },
        { href: "#projects", label: "projets" },
        { href: "#services", label: "services" },
        { href: "#contact", label: "contact" },
      ],
      status: "open for work",
      ariaCustomize: "Personnaliser",
    },
    hero: {
      meta1: "// PORTFOLIO · 2.0 · 2026",
      meta2: "// SENIOR FULLSTACK · 5+Y EXP · ABIDJAN / REMOTE",
      titles: ["fullstack", "product", "shipping", "reliable"],
      h1Pre: "Je build",
      h1Accent: "des produits",
      sub: "Senior Fullstack. 5+ ans à concevoir, livrer et maintenir des produits web & mobile en production — du <strong>back haute charge</strong> au <strong>front nerveux</strong>, du POC à la mise à l'échelle.",
      terminal: {
        whoamiCmd: "whoami --verbose",
        whoamiOut: "→ TRAORE Lamine · Senior Fullstack · 5+ y exp",
        catCmd: "cat ~/now.json",
        jsonLines: [
          "{",
          '  "location"   : "Abidjan, CI / full remote",',
          '  "current"    : "Asernum — Senior Fullstack",',
          '  "open_for"   : ["freelance", "CDI"],',
          '  "timezone"   : "GMT+0",',
          '  "status"     : "available"',
          "}",
        ],
        stackCmd: "stack --short",
        stackLines: [
          "JS · TS · PHP · Dart · Go-curious",
          "NestJS · Next · Laravel · Flutter · React",
          "Postgres · MySQL · Mongo · Redis · Kafka",
        ],
        pingCmd: "ping --since 2020",
        pingOk: "OK · 30+ projets · 0 dropped packet 🙂",
        replayHint: "Cliquer pour rejouer",
        hint: "Terminal interactif — tape 'help'",
        skipHint: "Cliquer pour passer l'intro",
        tryHelp: "// ce terminal est interactif — tape 'help' pour explorer",
        notFound: (c) => `zsh: command not found: ${c} — essaie 'help'`,
        helpTitle: "commandes disponibles :",
        helpRows: [
          ["help", "cette liste"],
          ["whoami", "qui je suis"],
          ["projects", "les projets (+ scroll)"],
          ["stack", "la stack technique"],
          ["contact", "ouvrir le formulaire"],
          ["github · linkedin", "mes profils"],
          ["rain on|off", "la pluie d'Abidjan + son"],
          ["theme dark|light", "mode sombre / clair"],
          ["lang fr|en", "changer de langue"],
          ["clear · replay", "nettoyer · rejouer l'intro"],
          ["sudo hire-me", "???"],
        ],
        gotoOut: (s) => `→ direction ${s}…`,
        rainOn: "→ pluie d'Abidjan activée ☔",
        rainOff: "→ pluie coupée",
        themeOut: (m) => `→ thème : ${m}`,
        langOut: (l) => `→ langue : ${l}`,
        openOut: (u) => `→ ouverture de ${u}…`,
        sudoSteps: [
          "[sudo] mot de passe pour guest : ••••••••",
          "accès accordé ✔",
          "initialisation du protocole hire-me…",
          "→ ouverture du formulaire de contact",
        ],
        sudoDenied: "guest n'est pas dans le fichier sudoers. essaie : sudo hire-me",
        lsOut: "about/  stack/  parcours/  projets/  stats/  services/  contact/  now.json",
        pwdOut: "/home/lamine/abidjan",
        catErr: (f) => `cat: ${f}: No such file or directory`,
        projectsTitle: "7 produits en production :",
        exitOut: "logout… non, en fait non. tu restes 🙂",
      },
      weather: {
        live: "il pleut vraiment à Abidjan en ce moment",
        cta: "écouter la pluie →",
        on: "∿ pluie activée — clic pour couper",
      },
    },
    about: {
      label: "// 01 — À propos",
      lede: "Salut, je suis <strong>Lamine</strong>. 5+ ans à livrer des produits qui tournent en production — pour des institutions publiques, des retailers et des startups.<br/><br/>J'aime les <em>systèmes propres</em>, les <em>APIs nettes</em>, et le code qu'on peut relire dans six mois sans pleurer. J'aime aussi savoir <em>pourquoi</em> on construit ce qu'on construit.",
      metaName: "Nom",
      metaRole: "Rôle",
      metaBased: "Basé à",
      metaSetup: "Setup",
      metaAvail: "Dispo",
      photoAlt: "TRAORE Lamine, développeur fullstack senior basé à Abidjan, Côte d'Ivoire",
      photoCmd: "whoami --photo",
      photoModes: "Choisir la photo",
      photoCaption: "// Abidjan · 2026",
      photoHintHover: "hover = couleur",
      photoHintTap: "tap = couleur",
    },
    stack: {
      label: "// 02 — Stack technique",
      title:
        "Du <span class='accent'>front</span> aux <span class='accent-2'>events</span>, je tiens la chaîne entière.",
    },
    timeline: {
      label: "// 03 — Parcours significatif",
      title:
        "Trois maisons.<br/>Une <span class='accent'>obsession</span> : livrer.",
      now: "● now",
    },
    projects: {
      label: "// 04 — Sélection",
      title:
        "Sept produits auxquels j'ai contribué en <span class='accent'>production</span>.",
      prefix: "PROJET · ",
    },
    stats: {
      label: "// 05 — Chiffres",
      title: "Ce que <span class='accent'>5+ ans</span> donnent.",
    },
    services: {
      label: "// 06 — Freelance",
      title: "Trois façons de bosser <span class='accent'>ensemble</span>.",
      cardOf: "/ 03",
    },
    contact: {
      label: "// 07 — Contact",
      giantLine1: "On",
      giantAccent: "build",
      giantLine2: "quelque chose",
      giantLine3: "ensemble ?",
      cta: "Démarrer un projet",
      footer: "© 2026 · TRAORE Lamine · Made with love in Abidjan",
    },
    modal: {
      heading: "// 000 — DÉMARRER UN PROJET",
      sub: "Réponds sous 24h — toujours.",
      labelName: "Nom complet",
      phName: "TRAORE Lamine",
      labelEmail: "Email",
      phEmail: "lahmine@nomail.com",
      labelType: "Type de projet",
      phType: "— Choisir",
      projectTypes: [
        { value: "Build from scratch", label: "Build from scratch" },
        { value: "Lead / scale équipe", label: "Lead / scale équipe" },
        { value: "Mission ponctuelle", label: "Mission ponctuelle" },
        { value: "Audit & conseil", label: "Audit & conseil" },
        { value: "Autre", label: "Autre" },
      ],
      labelMsg: "Message",
      phMsg:
        "Décris ton projet en quelques lignes — stack, timing, contexte...",
      hint: "↳ Réponse garantie sous 24h.",
      send: "Envoyer →",
      sending: "Envoi...",
      successTitle: "Message envoyé.",
      successSub: "Je te lis dès que possible — en général sous 24h.",
      countdown: (n) => `Fermeture dans ${n}s`,
      errorText: "Échec d'envoi. Réessaie ou écris directement à",
    },
    theme: {
      heading: "// 00 — PERSONNALISER",
      paletteLabel: "PALETTE",
      paletteHint: "↑↓ ou clic",
      modeLabel: "MODE",
      active: "● ACTIF",
    },
  },

  en: {
    nav: {
      links: [
        { href: "#about", label: "about" },
        { href: "#stack", label: "stack" },
        { href: "#exp", label: "experience" },
        { href: "#projects", label: "projects" },
        { href: "#services", label: "services" },
        { href: "#contact", label: "contact" },
      ],
      status: "open for work",
      ariaCustomize: "Customize",
    },
    hero: {
      meta1: "// PORTFOLIO · 2.0 · 2026",
      meta2: "// FULLSTACK DEV · 5+ Y EXP · ABIDJAN / REMOTE",
      titles: ["fullstack", "product", "shipping", "reliable"],
      h1Pre: "I build",
      h1Accent: "products",
      sub: "Fullstack developer. 5+ years designing, shipping and maintaining web & mobile products in production — from <strong>high-traffic back-end</strong> to <strong>snappy front-end</strong>, from POC to scale.",
      terminal: {
        whoamiCmd: "whoami --verbose",
        whoamiOut: "→ TRAORE Lamine · Fullstack Developer · 5+ y exp",
        catCmd: "cat ~/now.json",
        jsonLines: [
          "{",
          '  "location"   : "Abidjan, CI / full remote",',
          '  "current"    : "Asernum — Fullstack Developer",',
          '  "open_for"   : ["freelance", "full-time"],',
          '  "timezone"   : "GMT+0",',
          '  "status"     : "available"',
          "}",
        ],
        stackCmd: "stack --short",
        stackLines: [
          "JS · TS · PHP · Dart · Go-curious",
          "NestJS · Next · Laravel · Flutter · React",
          "Postgres · MySQL · Mongo · Redis · Kafka",
        ],
        pingCmd: "ping --since 2020",
        pingOk: "OK · 30+ projects · 0 dropped packet 🙂",
        replayHint: "Click to replay",
        hint: "Interactive terminal — type 'help'",
        skipHint: "Click to skip the intro",
        tryHelp: "// this terminal is interactive — type 'help' to explore",
        notFound: (c) => `zsh: command not found: ${c} — try 'help'`,
        helpTitle: "available commands:",
        helpRows: [
          ["help", "this list"],
          ["whoami", "who I am"],
          ["projects", "the projects (+ scroll)"],
          ["stack", "the tech stack"],
          ["contact", "open the contact form"],
          ["github · linkedin", "my profiles"],
          ["rain on|off", "Abidjan rain + sound"],
          ["theme dark|light", "dark / light mode"],
          ["lang fr|en", "switch language"],
          ["clear · replay", "clear · replay the intro"],
          ["sudo hire-me", "???"],
        ],
        gotoOut: (s) => `→ heading to ${s}…`,
        rainOn: "→ Abidjan rain enabled ☔",
        rainOff: "→ rain muted",
        themeOut: (m) => `→ theme: ${m}`,
        langOut: (l) => `→ language: ${l}`,
        openOut: (u) => `→ opening ${u}…`,
        sudoSteps: [
          "[sudo] password for guest: ••••••••",
          "access granted ✔",
          "initializing hire-me protocol…",
          "→ opening the contact form",
        ],
        sudoDenied: "guest is not in the sudoers file. try: sudo hire-me",
        lsOut: "about/  stack/  experience/  projects/  stats/  services/  contact/  now.json",
        pwdOut: "/home/lamine/abidjan",
        catErr: (f) => `cat: ${f}: No such file or directory`,
        projectsTitle: "7 products in production:",
        exitOut: "logout… actually no. you're staying 🙂",
      },
      weather: {
        live: "it's actually raining in Abidjan right now",
        cta: "listen to the rain →",
        on: "∿ rain on — click to mute",
      },
    },
    about: {
      label: "// 01 — About",
      lede: "Hey, I'm <strong>Lamine</strong>. 5+ years shipping products running in production — for public institutions, retailers and startups.<br/><br/>I like <em>clean systems</em>, <em>neat APIs</em>, and code you can re-read six months later without crying. I also like knowing <em>why</em> we're building what we're building.",
      metaName: "Name",
      metaRole: "Role",
      metaBased: "Based in",
      metaSetup: "Setup",
      metaAvail: "Available",
      photoAlt: "TRAORE Lamine, senior fullstack developer based in Abidjan, Côte d'Ivoire",
      photoCmd: "whoami --photo",
      photoModes: "Pick the photo",
      photoCaption: "// Abidjan · 2026",
      photoHintHover: "hover = colour",
      photoHintTap: "tap = colour",
    },
    stack: {
      label: "// 02 — Tech stack",
      title:
        "From <span class='accent'>front</span> to <span class='accent-2'>events</span>, I own the full chain.",
    },
    timeline: {
      label: "// 03 — Significant Experience",
      title:
        "Three companies.<br/>One <span class='accent'>obsession</span>: ship.",
      now: "● now",
    },
    projects: {
      label: "// 04 — Selection",
      title:
        "Seven products I contributed to in <span class='accent'>production</span>.",
      prefix: "PROJECT · ",
    },
    stats: {
      label: "// 05 — Numbers",
      title: "What <span class='accent'>5+ years</span> look like.",
    },
    services: {
      label: "// 06 — Freelance",
      title: "Three ways to work <span class='accent'>together</span>.",
      cardOf: "/ 03",
    },
    contact: {
      label: "// 07 — Contact",
      giantLine1: "Shall we",
      giantAccent: "build",
      giantLine2: "something",
      giantLine3: "together?",
      cta: "Start a project",
      footer: "© 2026 · TRAORE Lamine · Made with love in Abidjan",
    },
    modal: {
      heading: "// 000 — START A PROJECT",
      sub: "Replies within 24h — always.",
      labelName: "Full name",
      phName: "TRAORE Lamine",
      labelEmail: "Email",
      phEmail: "lahmine@nomail.com",
      labelType: "Project type",
      phType: "— Choose",
      projectTypes: [
        { value: "Build from scratch", label: "Build from scratch" },
        { value: "Lead / scale team", label: "Lead / scale team" },
        { value: "Targeted mission", label: "Targeted mission" },
        { value: "Audit & consulting", label: "Audit & consulting" },
        { value: "Other", label: "Other" },
      ],
      labelMsg: "Message",
      phMsg: "Describe your project in a few lines — stack, timing, context...",
      hint: "↳ Reply guaranteed within 24h.",
      send: "Send →",
      sending: "Sending...",
      successTitle: "Message sent.",
      successSub:
        "I'll get back to you as soon as possible — usually within 24h.",
      countdown: (n) => `Closing in ${n}s`,
      errorText: "Failed to send. Try again or write directly to",
    },
    theme: {
      heading: "// 00 — CUSTOMIZE",
      paletteLabel: "PALETTE",
      paletteHint: "↑↓ or click",
      modeLabel: "MODE",
      active: "● ACTIVE",
    },
  },
};
